import { render, staticRenderFns } from "./skeleton_note.vue?vue&type=template&id=509879a6&"
import script from "./skeleton_note.vue?vue&type=script&lang=js&"
export * from "./skeleton_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "skeleton_note.vue"
export default component.exports